import { getHours, getMinutes, getSeconds, setHours, setMinutes, setSeconds } from 'date-fns'

const setTimeForDay = (time, date = new Date()) =>
  setHours(setMinutes(setSeconds(date, getSeconds(time)), getMinutes(time)), getHours(time))

export default setTimeForDay
